"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AEArtNrGeneratorFactory = void 0;
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const DefaultAEArtNrGenerator_1 = require("./DefaultAEArtNrGenerator");
const TypeAMountArtNrGenerator_1 = require("./TypeAMountArtNrGenerator");
/**
 * The `AEArtNrGeneratorFactory` creates instances of concrete generators
 */
class AEArtNrGeneratorFactory {
    /**
     * Retrieves a concrete AEArtNr Generator for a given AE `Series` number.
     *
     * If the `AE` of the `Series` is unknown, it will retrieve a default provider.
     */
    static instanceOf(artNr) {
        var _a;
        const separator = echain_shared_i18n_1.LocaleService.getArtNrSeparator();
        const artNrSplit = artNr.split(separator);
        if ((_a = artNrSplit.at(-1)) === null || _a === void 0 ? void 0 : _a.includes('A')) {
            return new TypeAMountArtNrGenerator_1.TypeAMountArtNrGenerator();
        }
        return new DefaultAEArtNrGenerator_1.DefaultAEArtNrGenerator();
    }
}
exports.AEArtNrGeneratorFactory = AEArtNrGeneratorFactory;
AEArtNrGeneratorFactory.className = 'AEArtNrGeneratorFactory';
//# sourceMappingURL=AEArtNrGeneratorFactory.js.map